import styled from 'styled-components';
import { Flex } from '../../../../../Flex';
export var Button = styled(Flex).attrs(function (_ref) {
  var active = _ref.active,
      background = _ref.background;
  return active && {
    color: 'base.white',
    backgroundColor: background,
    boxShadow: '0 1px 10px rgba(0, 0, 0, 0.12)'
  };
}).withConfig({
  displayName: "styled__Button",
  componentId: "sc-233pc9-0"
})(["border-radius:8px;justify-content:center;align-items:center;width:50px;height:30px;cursor:pointer;"]);